import { addMerkzettelIconToAdvertCard, getAdvertCardMerkzettelId } from "@modules/advert-cards/advert-cards"
import { getMerkzettelIds } from "@modules/merkzettel/merkzettel"
import { isPC } from "@modules/util/device"
import { advertCardsContainerElement } from "../global/dom.ts"
import { getQueryParameter } from "../util/query-parameter"

export async function addMerkzettelIconToAdvertCards() {
    // no highlighting inside gallery cards
    if (getQueryParameter("ansicht") === "gallery" || (isPC() && getQueryParameter("ansicht") !== "list")) return
    const cards = advertCardsContainerElement()?.children || []
    const merkzettelIds = await getMerkzettelIds()

    for (const card of cards) {
        const id = getAdvertCardMerkzettelId(card)
        if (id === null) {
            continue
        }

        if (merkzettelIds.includes(id)) {
            addMerkzettelIconToAdvertCard(card)
        }
    }
}

addMerkzettelIconToAdvertCards()
